module.exports = __webpack_public_path__ + "img/racold.aceaa0de.png";